import { render, staticRenderFns } from "./batchlist.vue?vue&type=template&id=0b513c0a&scoped=true&"
import script from "./batchlist.vue?vue&type=script&lang=js&"
export * from "./batchlist.vue?vue&type=script&lang=js&"
import style0 from "./batchlist.vue?vue&type=style&index=0&id=0b513c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b513c0a",
  null
  
)

export default component.exports